export const PoweredBy = ({
  utmSource,
  prependText = 'Powered by'
}: {
  utmSource: string;
  prependText?: string;
}): JSX.Element => {
  return (
    <div className="text-sm text-gray-600">
      {prependText}{' '}
      <a
        href={`/?utm_source=${utmSource}`}
        className="text-primary-2 hover:text-primary"
        target="_blank"
        rel="noreferrer"
      >
        Recover
      </a>
    </div>
  );
};
